import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import Container from '../../Home/Container';
import TitleContent from '../../TinyComponents/TitleContent';
import { LocalizationContext } from '../../../hoc/Localization';
import CardList from '../CardList';
import Header from '../../CardList/Header';
import SingleBlog from '../../SchoolComponents/Blog';
import styles from './styles.less';

const BlogBody = ({ blog, seeMoreRoute, category, isDetail }) => {
  const { locale, translate } = React.useContext(LocalizationContext);

  return (
    <Element name={blog.label || 'teachers'}>
      <Container key={blog.label}>
        <TitleContent
          key={blog.title}
          title={
            isDetail && (
              <React.Fragment key={`${blog.label}fragment`}>
                <h2>{translate(blog, 'title')}</h2>
                {!!blog.description && <p className={styles.subtitle}>{blog.description}</p>}
              </React.Fragment>
            )
          }
          content={
            <TitleContent
              key={`${blog.title}2`}
              title={
                !isDetail && (
                  <Header
                    key={`${blog.label}header`}
                    title={blog.title}
                    linkOptions={
                      category
                        ? {
                          route: seeMoreRoute || 'blogCategory',
                          locale,
                          category,
                          subCategory: blog.label,
                        }
                        : {
                          route: seeMoreRoute || 'blogCategory',
                          locale,
                          category: blog.label,
                        }
                    }
                    link={blog.data.length > 6}
                  />
                )
              }
              content={
                blog.data && blog.data.length > 1 ? (
                  <CardList
                    key={`${blog.label}cardlist`}
                    blogs={!isDetail ? blog.data.slice(0, 6) : blog.data}
                    reference="blog"
                  />
                ) : (
                  <SingleBlog blog={blog.data[0]} />
                )
              }
            />
          }
        />
      </Container>
    </Element>
  );
};

BlogBody.propTypes = {
  blog: PropTypes.object,
  category: PropTypes.string,
  seeMoreRoute: PropTypes.string,
  isDetail: PropTypes.bool,
};

BlogBody.defaultProps = {
  blog: {},
  category: '',
  seeMoreRoute: '',
  isDetail: false,
};

export default BlogBody;
